export class TemplateTransformer {

  static transform(obj) {

    const data = obj.hasOwnProperty('attributes') ? obj.attributes : obj;

    return Object.assign({id: obj.id}, data);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/templates/template.transformer.js